<template>
  <section class="container">
    <el-form label-width="100px">
      <el-form-item label="标题">
        <el-input v-model="editObject.product_title"/>
      </el-form-item>
      <el-form-item label="副标题">
        <el-input v-model="editObject.product_son_title"/>
      </el-form-item>
      <el-form-item label="英文标题">
        <el-input v-model="editObject.product_english_title"/>
      </el-form-item>
      <el-form-item label="英文副标题">
        <el-input v-model="editObject.product_english_son_title"/>
      </el-form-item>
      <el-form-item label="价格">
        <el-input-number
          v-model="editObject.product_now_price"
          :precision="2"
          :min="0"
          :step="1"/>
          <!-- <el-input v-model="editObject.product_now_price"/> -->
      </el-form-item>
      <el-form-item label="原价">
        <el-input-number
          v-model="editObject.product_price"
          :precision="2"
          :min="0"
          :step="1"/>
          <!-- <el-input v-model="editObject.product_price"/> -->
      </el-form-item>
      <el-form-item label="权重">
        <el-input-number
          v-model="editObject.product_sort"
          :min="1" />
          <!-- <el-input v-model="editObject.product_sort"/> -->
      </el-form-item>
      <el-form-item label="图片">
        <el-upload
          class="avatar-uploader"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadSuccess"
          :show-file-list="false">
          <img
            v-if="editObject.product_icon"
            :src="qiniuDomain + editObject.product_icon"
            class="avatar">
          <i
            v-else
            class="el-icon-plus avatar-uploader-icon"/>
        </el-upload>
      </el-form-item>
      <el-form-item label="banner">
        <el-upload
          class="upload-demo"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadBannerSuccess"
          :show-file-list="false"
          list-type="picture">
          <el-button
            size="small"
            type="primary">点击上传</el-button>
        </el-upload>
        <img
          v-if="editObject.product_banner"
          :src="qiniuDomain + editObject.product_banner"
          class="banner-img">
      </el-form-item>
      <el-form-item>
        <el-button
          @click="onSave"
          type="primary">保存</el-button>
      </el-form-item>
    </el-form>

  </section>
</template>

<script>
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  addProduct, editProduct, productDetail,
} from '@/api/product'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      editObject: { //  根据接口来的命名，不是很喜欢---
        product_title: '',
        product_son_title: '',
        product_english_title: '',
        product_english_son_title: '',
        product_icon: '',
        product_sort: '',
        product_banner: '',
        product_price: '',
        product_now_price: '',
      },
    };
  },


  created() {
    this.network().getQiniuInfo()
  },
  methods: {
    routerTo(url) {
      this.$router.push({
        path: url,
      })
    },
    onSave() {
      if (!this.event().inputVerify()) return
      this.network().addProduct()
    },
    uploadBannerSuccess(res) {
      this.editObject.product_banner = res.hash
    },
    uploadSuccess(res) {
      this.editObject.product_icon = res.hash
    },
    event() {
      return {
        inputVerify: () => {
          if (!this.editObject.product_title) {
            this.$message('请填写标题')
            return false
          }
          if (!this.editObject.product_son_title) {
            this.$message('请填写副标题')
            return false
          }
          if (!this.editObject.product_english_title) {
            this.$message('请填写英文标题')
            return false
          }
          if (!this.editObject.product_english_son_title) {
            this.$message('请填写英文副标题')
            return false
          }
          if (!this.editObject.product_sort) {
            this.$message('请填写权重')
            return false
          }
          if (!this.editObject.product_icon) {
            this.$message('请上传图片')
            return false
          }
          if (!this.editObject.product_banner) {
            this.$message('请上传banner')
            return false
          }
          return true
        },
      }
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        productDetail: async () => {
          const { status, data } = await productDetail({
            uuid: this.$route.params.uuid,
          })
          if (status === 200) {
            this.editObject = data
          }
        },
        addProduct: async () => {
          const { status } = await addProduct(this.editObject)
          if (status === 200) {
            this.$message({
              message: '添加成功',
              type: 'success',
            })
          }
        },
        editProduct: async () => {
          const { status } = await editProduct(this.editObject)
          if (status === 200) {
            this.$message({
              message: '更新成功',
              type: 'success',
            })
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
    .el-form {
    width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/product/add.vue